<script lang="typescript">
    import LensBenefitImage from "./LensBenefitImage.svelte";

    export let title: string;
    export let image: string;
    export let classNames: string = "";
    export let description: string;

    let imageIsActive = false;

    const handleMouseEnter = () => {
        imageIsActive = true;
    };
    const handleMouseLeave = () => {
        imageIsActive = false;
    };
</script>

<div
    class="local-container {classNames}"
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
>
    <LensBenefitImage isActive={imageIsActive} {image} />
    <div class="flex flex-col justify-center ml-4">
        <h3 class="py-0 text-xl font-medium">{title}</h3>
        <p>{description}</p>
    </div>
</div>

<style>
    .local-container {
        @apply w-full mt-6 px-4 flex justify-start items-center cursor-default;
        @apply flex-row xl:mx-auto;
    }
</style>
